<template>
  <div class="inner-top" :class="En ? 'inner-top-en' : ''" v-if="text">
    <!-- <img class="inner-top-img" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-forums-en.png" alt="">
    <img class="inner-top-img" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-forums.png" alt=""> -->
    <div class="inner-top-text">
          <em v-html="text"></em>
					<div class="small" v-html="formDataText(text)"></div>
		</div>
    <div class="line" v-if="!noText"></div>
    <img class="inner-top-icon" v-if="!noText" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/text-icon.png" alt="">
    <span v-if="!noText">{{ $t('newbanner5') }}</span>
  </div>
</template>

<script>
export default {
  name: 'innerTop',
  props: {
    noText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      redTexts: ['CIIF', '工博会', 'HALL', '展区', '下载', '参展', 'VISA', '签证', 'PROCESS', '流程','HOTEL','酒店','CATERING','餐饮','RECEPTION','接待','EXHIBITION HALL','展馆','TRANSPORTTATION','交通','BROCHURE','招展书','MATERIAL','素材', 'LOGIN', '登录', 'APPLY', '注册系统', 'REGISTRATION']
    }
  },
  computed: {
    formDataText() {
      return text => {
        text = text.toUpperCase()
        let str = text
        this.redTexts.forEach(x => {
          if (text.includes(x)) {
            if (this.En) {
              str = text.replace(x, `<font style="color: #F4501C; font-family: Inter Black">${ x }</font>`)
            } else {
              str = text.replace(x, `<font style="color: #F4501C; font-family: MiSans Bold">${ x }</font>`)
            }
          }
        })
        return str
      }
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .inner-top {
    position: absolute;
    left: 0;
    top: 192px;
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 140px;
    z-index: 1;
    pointer-events: none;

    .inner-top-img {
      width: auto;
      height: 120px;
    }

    .inner-top-text {
        max-width: 1500px;
				font-family: MiSans Bold;
				font-size: 120px;
        color: rgba(11, 36, 63, 0.04);
				line-height: 120px;
				text-align: left;
				font-style: normal;
				text-transform: uppercase;
				position: relative;
        font-weight: bold;
				
				.small {
					position: absolute;
					width: 100%;
					left: 140px;
					top: -10px;
					transform: scale(0.6);
          color: #0B243F;
					transform-origin: left top;
					font-weight: bold;
          font-family: MiSans Bold;
				}
			}

    .line {
      flex: 1;
      margin: 0 16px 0 10px;
      height: 2px;
      background: #0B243F;
      opacity: 0.05;
      overflow: hidden;
    }

    .inner-top-icon {
      width: 32px;
      height: auto;
      margin-right: 4px;
    }

    span {
      font-family: MiSans, MiSans;
      font-weight: 600;
      font-size: 16px;
      color: #999999;
      line-height: 26px;
      text-align: left;
      font-style: normal;
    }

    &.inner-top-en {

      .inner-top-text {
        font-family: Inter Black;

        .small {
          font-family: Inter Black;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .inner-top {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 0.9rem;
    margin-bottom: .6rem;
    padding-top: .1rem;
    overflow: hidden;

    .inner-top-img {
      width: auto;
    }

    .inner-top-text {
				font-family: MiSans Bold;
				font-size: 0.95rem;
        color: rgba(11, 36, 63, 0.04);
				line-height: 1.05rem;
				text-align: left;
				font-style: normal;
				text-transform: uppercase;
				position: relative;
				
				.small {
					position: absolute;
					width: 100%;
					left: .4rem;
					top: -0.2rem;
          font-size: .8rem;
          color: #0B243F;
					transform-origin: left top;
          font-family: MiSans Bold;
				}
			}

    .line {
      display: none;
    }

    .inner-top-icon {
      display: none;
    }

    span {
      display: none;
    }

    &.inner-top-en {

      .inner-top-text {
        font-family: Inter Black;

        .small {
          font-family: Inter Black;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/innerTop.vue